<template>
  <v-app>
    <drawer-bar />
    <v-main >
      <v-content>
        <v-fade-transition >
          <router-view></router-view>
        </v-fade-transition>
      </v-content>
    </v-main>
    <FootersTab />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DrawerBar from "./components/DrawerBar.vue";
import FootersTab from "./components/FootersTab.vue";

export default defineComponent({
  components: { DrawerBar, FootersTab },
  name: "App",

  data() {
    return {
      //
    };
  },
});
</script>
